import { connect } from 'react-redux';
import ChartDonut from './ChartDonut';

export default connect(null, null)(ChartDonut);
